import { createFileRoute } from "@tanstack/react-router";
import { TopRelatedManager } from "@/components/admin/top-related-manager";

export const Route = createFileRoute("/_authenticated/admin/top-related")({
  component: TopRelatedManager,
});
